export default class Parallaxable {
  constructor(el) {
    if (!el) {
      return;
    }

    this.$el = el;
    this.y = 0;
    this.lastPosition = window.pageYOffset;
    this.$cover = this.$el.querySelector('[data-ref="parallaxable.cover"]');
    this.elBCR = this.$el.getBoundingClientRect();
    // this.$cover.style.transition = 'transform .1s';

    this.bind();
    this.initObserver();
  }

  initObserver() {
    this.observer = new IntersectionObserver(this.checkVisibility, {
      threshold: 0.1
    });
    this.observer.observe(this.$el);
  }

  checkVisibility(entries) {
    if (entries[0].isIntersecting) {
      this.raf = requestAnimationFrame(this.update);
    } else {
      cancelAnimationFrame(this.raf);
    }
  }

  bind() {
    this.onScroll = this.onScroll.bind(this);
    this.update = this.update.bind(this);
    this.checkVisibility = this.checkVisibility.bind(this);
    window.addEventListener('wheel', this.onScroll);
  }

  onScroll(e) {
    this.direction = this.getYDelta(e) ? 'up' : 'down';
  }

  getYDelta(event) {
    if (event.wheelDelta) {
      return event.wheelDelta > 0;
    }

    return event.deltaY < 0;
  }


  update(entries) {
    const multiplier = 0.2;

    this.y = window.pageYOffset * multiplier;
    this.$cover.style.willChange = 'transform';
    this.$cover.style.transform = `translateY(${this.y}px)`;
    this.lastPosition = window.pageYOffset;
    this.raf = requestAnimationFrame(this.update);
  }
}
